/**
 * Generates a universally unique identifier (UUID).
 *
 * This function attempts to use the `crypto.randomUUID` method if available,
 * which is a built-in method for generating UUIDs. If `crypto.randomUUID` is
 * not available, it falls back to generating a UUID using `crypto.getRandomValues`.
 *
 * @returns {string} A string representing the generated UUID.
 */
export const uuid = () => {
  if (globalThis.crypto.randomUUID) {
    return globalThis.crypto.randomUUID();
  }
  // https://stackoverflow.com/a/2117523
  // generate RFC4122-compliant UUIDs.
  // These are used in E2E tests where a secure context (https) does not exist.
  // getRandomValues is the only crypto method that exists outside of https
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (character) =>
    (
      +character ^
      ((globalThis.crypto?.getRandomValues(new Uint8Array(1))[0] ?? 0) &
        (15 >> (+character / 4)))
    ).toString(16),
  );
};
